import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { IUpdateWalletTagsPayload, IWalletTags } from '@kattana-io/common';
import { LOG_OUT, SET_AUTH } from '../actions/auth';
import { WalletAPI } from '../store/createStore';
import {
  UPDATE_WALLET_TAGS,
  actionClearWalletTags,
  actionSetWalletTags,
  actionUpdateSuccessWalletTags,
} from '../actions/wallet_tags';
import { authTokenSelector } from '../selectors/auth';
import { IStore } from '../reducers';
import { actionShowModal } from '../actions/modal';
import { ModalTypes } from '../reducers/modal';
import { actionCreateNotification } from '../actions/notifications';

function* onUpdate(action: any): any {
  try {
    const payload: IUpdateWalletTagsPayload = action.payload;
    const token = yield select(authTokenSelector);
    const { loggedIn } = yield select((store: IStore) => store.auth);

    if (!loggedIn) {
      // show connect modal
      yield put(actionShowModal(ModalTypes.connect, {}));
      return;
    }

    const data = yield call(WalletAPI.updateWalletTags, payload, token);
    if (data.success) {
      yield put(actionUpdateSuccessWalletTags(payload));
    } else {
      console.error(data.error);
      yield put(
        actionCreateNotification({
          kind: 'warning',
          message: 'Failed to update wallet tags...',
        })
      );
    }
  } catch (error) {
    yield put(
      actionCreateNotification({
        kind: 'warning',
        message: 'Failed to update wallet tags...',
      })
    );
    console.error(error);
  }
}

function* onAuth(): any {
  const token = yield select(authTokenSelector);
  if (token) {
    const walletTags: IWalletTags | null = yield call(
      WalletAPI.fetchWalletTags,
      token
    );
    if (walletTags) {
      yield put(actionSetWalletTags(walletTags));
    } else {
      yield put(actionClearWalletTags());
    }
  }
}

function* onLogOut(): any {
  yield put(actionClearWalletTags());
}

export default function* walletTagsSaga() {
  yield takeLatest(SET_AUTH, onAuth);
  yield takeLatest(LOG_OUT, onLogOut);
  yield takeEvery(UPDATE_WALLET_TAGS, onUpdate);
}
